import { render, staticRenderFns } from "./permissionForm.vue?vue&type=template&id=c9870dea&scoped=true"
import script from "./permissionForm.vue?vue&type=script&lang=js"
export * from "./permissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9870dea",
  null
  
)

export default component.exports